import React from 'react';
import styled from 'styled-components';
import theme from './../theme';
import convertirAMoneda from './../funciones/convertirAMoneda';
import { useTotalDelMes } from './../contextos/TotalGastadoEnElMes';
import { useTotalIngresosDelMes } from './../contextos/TotalGanadoEnElMes';

const BarraTotal = styled.div`
    background: ${theme.verdeFecha};
    width: 100%;
    padding: 0.62rem 2.25rem; /* 10px 40px */
    display: flex;
    justify-content: space-around;
    align-items: center;
 
    @media(max-width: 31.25rem) { /* 500px */
        flex-direction: column;
        flex-wrap: wrap;
    }
`;

const CajaTotal = styled.div`
    width: 30%;
    font-size: 1rem;
    padding: 0.5rem 0;
    letter-spacing: 1px;
    font-weight: 500;
    text-transform: uppercase;
    color: #fff;

    @media(max-width: 31.25rem) { /* 500px */
        font-size: 14px;
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

const Amarillo = styled.p`
    color: #FFAD00;
`;

const Rojo = styled.p`
    color: #FF0000;
    text-shadow: 0px 0px 10px #FC4F4F;
`;

const Verde = styled.p`
    color: #09C825;
`;

const BarraTotalGastado = () => {
    const {total} = useTotalDelMes();
    const totalIngresos = useTotalIngresosDelMes();

    return (  
        <>
            <BarraTotal>
                <CajaTotal>
                    <p>Total de ingresos en el mes:</p>
                    <Verde>+{ convertirAMoneda(totalIngresos.total) }</Verde>
                </CajaTotal>
                <CajaTotal>
                    <p>Total gastado en el mes:</p>
                    <Rojo>-{ convertirAMoneda(total) }</Rojo>
                </CajaTotal>
                <CajaTotal>
                    <p>Total ahorrado en el mes:</p>
                    <Amarillo>{ convertirAMoneda(totalIngresos.total - total) }</Amarillo>
                </CajaTotal>
            </BarraTotal>
        </>
    );
}
 
export default BarraTotalGastado;